import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'

type Props = {
  label: string | React.ReactFragment
  required?: boolean
  error?: any
}

export const Label: React.FC<Props> = ({ label, required, error }) => {
  const { t } = useTranslation()
  return (
    <p className="__label" css={[labelStyle, error ? { color: 'red' } : {}]}>
      {label} {required && <div>{t('*')}</div>}
    </p>
  )
}
const labelStyle = css({
  color: '#676767',
  fontSize: 12,
  letterSpacing: 0.6,
  marginBottom: 11,
  fontWeight: 'bold',
  display: 'flex',
  '> div': {
    fontSize: 8,
    letterSpacing: 0.4,
    paddingLeft: 8,
  },
})
